import React, { useEffect, createElement } from 'react';
import { useLocation } from 'react-router-dom';
interface MetaPixelProps {
  children: React.ReactNode;
}
export function MetaPixel({
  children
}: MetaPixelProps) {
  const location = useLocation();
  // Initialize Meta Pixel
  useEffect(() => {
    // This follows the exact implementation from Meta's official pixel code
    if (typeof window !== 'undefined') {
      // Only run in browser environment
      const f = window;
      const b = document;
      const e = 'script';
      const v = 'https://connect.facebook.net/en_US/fbevents.js';
      if (f.fbq) return;
      const n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e);
      t.async = true;
      t.src = v;
      // Handle the case where there might not be any script tags yet
      const s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        // Fallback to appending to head if no script tags exist
        const head = b.getElementsByTagName('head')[0];
        if (head) {
          head.appendChild(t);
        }
      }
      fbq('init', '4205753603074942');
      fbq('track', 'PageView');
      // Add the noscript pixel image as well
      const noscriptEl = document.createElement('noscript');
      const pixelImg = document.createElement('img');
      pixelImg.height = 1;
      pixelImg.width = 1;
      pixelImg.style.display = 'none';
      pixelImg.src = 'https://www.facebook.com/tr?id=4205753603074942&ev=PageView&noscript=1';
      noscriptEl.appendChild(pixelImg);
      // Try to add it to the body
      if (document.body) {
        document.body.appendChild(noscriptEl);
      }
    }
  }, []);
  // Track page changes when route changes
  useEffect(() => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'PageView');
      // Track additional information based on the page
      if (location.pathname === '/') {
        window.fbq('trackCustom', 'LandingPageVisit', {
          page: 'home',
          timestamp: new Date().toISOString()
        });
      }
    }
  }, [location]);
  return <>{children}</>;
}
// Helper function to track conversion events
export const trackPurchaseClick = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      content_category: 'Picadas Fáciles',
      content_name: 'Pack Completo Picadas Fáciles',
      currency: 'ARS',
      value: 14999.0
    });
  }
};
// Helper function to track when user views specific sections (can be called from components)
export const trackSectionView = (sectionName: string) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', 'SectionView', {
      section: sectionName,
      timestamp: new Date().toISOString()
    });
  }
};